import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CrudHelperService } from "@kdose/ng-crud";
import { BaseCrudService } from "../shared/base-crud.service";
import { NotificationService } from "../shared/notification.service";

@Injectable()
export class UserService extends BaseCrudService {
	constructor(
		protected helperService: CrudHelperService,
		protected notifyService: NotificationService,
		protected router: Router,
		protected http: HttpClient,
	) {
		super("users", helperService, notifyService, router, http);
	}
}
